import { render, staticRenderFns } from "./GruposTeacherList.vue?vue&type=template&id=528628ca"
import script from "./GruposTeacherList.vue?vue&type=script&lang=js"
export * from "./GruposTeacherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports